const FrontPage = {
    "options": {
        "data": {},
        "customization": {
            "logo": {
                "type": "ImageUploader"
            }
        }
    },
    "variants": [
        {
            "id": "FrontPage_1",
            "name": "FrontPage_1",
            "type": "FrontPage",
            "data": {
                "images": []
            },
            "customization": {
                "logo": ""
            },
            "variantData": {
                "isEditable": false,
                "aspectRatio": "1/1",
                "minImage": 4,
                "maxImage": 12,
                "modulo": 1,
                "renderTabs": {
                    "product": null
                }
            },
            "placeholderImage": "https://mobligo-bucket.s3.eu-central-1.amazonaws.com/signin.png",
            "minMobileAppVersion": 1,
            "isComingSoon": false
        }
    ]
}
 export default FrontPage